import { createLoginManualOutbound, createLoginOutbound, createVersionCheckOutbound } from '../../api/outbound/entryOutbounds';
import { createSetDisconnectionBehaviorOutbound } from '../../api/outbound/lobbyOutbounds';
import { isDisconnectionBehavior } from '../../types/disconnectionBehaviorTypes';
import { addMessageBox } from './messageBoxesActions';
import { setIsClientVersionOk, setTempLoginCredentials } from './sessionActions';
export const CLEAR_ENTRY_SCENE = 'CLEAR_ENTRY_SCENE';
export const SWITCH_TO_SIGN_UP = 'SWITCH_TO_SIGN_UP';
export const SWITCH_TO_LOGIN = 'SWITCH_TO_LOGIN';
export const SET_GAME_ENTRY_ACTION_IS_PENDING = 'SET_GAME_ENTRY_ACTION_IS_PENDING';
export const SET_LOGIN_STRING = 'SET_LOGIN_STRING';
export const SHOW_LOGIN_WINDOW_FROM_INBOUND = 'SHOW_LOGIN_WINDOW_FROM_INBOUND';
export const SET_SIGN_UP_AGREEMENT_IS_CONFIRMED = 'SET_SIGN_UP_AGREEMENT_IS_CONFIRMED';
export const SET_PENDING_LOGIN_CREDENTIALS = 'SET_PENDING_LOGIN_CREDENTIALS';
export const CLEAR_PENDING_LOGIN_CREDENTIALS = 'CLEAR_PENDING_LOGIN_CREDENTIALS';
export function clearEntryScene() {
    return {
        type: CLEAR_ENTRY_SCENE
    };
}
export function switchToSignUp() {
    return {
        type: SWITCH_TO_SIGN_UP
    };
}
export function switchToLogin() {
    return {
        type: SWITCH_TO_LOGIN
    };
}
export function setGameEntryActionPending(isPending) {
    return {
        type: SET_GAME_ENTRY_ACTION_IS_PENDING,
        payload: isPending
    };
}
export function setLoginString(loginString) {
    return {
        type: SET_LOGIN_STRING,
        payload: loginString
    };
}
export function showLoginWindowFromInbound(inbound) {
    return {
        type: SHOW_LOGIN_WINDOW_FROM_INBOUND,
        payload: inbound
    };
}
function maybeSetDisconnectionBehavior(socketSend) {
    const params = new URLSearchParams(window.location.search);
    const disconnectionBehavior = params.get('disconnectionBehavior');
    if (isDisconnectionBehavior(disconnectionBehavior)) {
        socketSend(createSetDisconnectionBehaviorOutbound(disconnectionBehavior));
    }
}
export function thunkLoginManual({ socketSend, username, password, skipReverifyCheck }) {
    return function (dispatch) {
        dispatch(setTempLoginCredentials({ username, password }));
        maybeSetDisconnectionBehavior(socketSend);
        socketSend(createLoginManualOutbound({ username, password, skipReverifyCheck }));
    };
}
/**
 * Handles the inbound when the server tells the client everything is OK and we can log in now.
 */
export function thunkLoginNow(socketSend) {
    return function (dispatch, getState) {
        const loginString = getState().gameEntry.loginString;
        if (!loginString) {
            throw new Error("Login string not available when 'login_now:' was received");
        }
        // clear temporary login credentials from redux since they shouldn't be needed any more:
        dispatch(setTempLoginCredentials(undefined));
        socketSend(createLoginOutbound(loginString));
    };
}
export function thunkStartLogin(socketSend, username, password) {
    return function (dispatch, getState) {
        dispatch(setGameEntryActionPending(true));
        const state = getState();
        if (state.session.isClientVersionOk !== undefined) {
            // already checked version and it's either ok, or the user confirmed the warning about being outdated:
            dispatch(thunkLoginManual({ socketSend, username, password, skipReverifyCheck: false }));
        }
        else {
            // need to check version before doing anything
            dispatch(setPendingLoginCredentials(username, password));
            socketSend(createVersionCheckOutbound());
        }
    };
}
export function setSignUpAgreementIsConfirmed() {
    return {
        type: SET_SIGN_UP_AGREEMENT_IS_CONFIRMED
    };
}
function setPendingLoginCredentials(username, password) {
    return {
        type: SET_PENDING_LOGIN_CREDENTIALS,
        payload: { username, password }
    };
}
export function clearPendingLoginCredentials() {
    return {
        type: CLEAR_PENDING_LOGIN_CREDENTIALS
    };
}
export function thunkHandleVersionCheckResultsFromInbound({ isClientVersionOk }, socketSend) {
    return function (dispatch, getState) {
        dispatch(setIsClientVersionOk(isClientVersionOk));
        if (!isClientVersionOk) {
            dispatch(addMessageBox({ type: 'outdated-client', isLoginConfirmation: false }));
        }
        else {
            const state = getState();
            const pendingLoginCredentials = state.gameEntry.pendingLoginCredentials;
            if (pendingLoginCredentials) {
                const { username, password } = pendingLoginCredentials;
                dispatch(thunkLoginManual({ socketSend, username, password, skipReverifyCheck: false }));
                dispatch(clearPendingLoginCredentials());
            }
        }
    };
}
